export default __webpack_public_path__ + "static/media/call.c8ac43f8.svg";